import { apiClient } from "@/lib/api-client";
import type {
  Condition,
  CreateConditionRequest,
  UpdateConditionRequest,
} from "@/types/condition";

export function getConditions() {
  return apiClient.get<Condition[]>("/api/customer/profile/conditions");
}

export function createCondition(data: CreateConditionRequest) {
  return apiClient.post<Condition>("/api/customer/profile/conditions", data);
}

export function updateCondition(id: string, data: UpdateConditionRequest) {
  return apiClient.put<Condition>(
    `/api/customer/profile/conditions/${id}`,
    data
  );
}

export function deleteCondition(id: string) {
  return apiClient.delete<void>(`/api/customer/profile/conditions/${id}`);
}
